import type { AppConfig, GConfig } from '@jwp/ott-common/types/config';

import { analyticsConfig, type AnalyticsConfig } from './analyticsConfig';
import { remoteConfig } from './remoteConfig';
import { webConfig } from './webConfig';

export type LocalAppConfigBundle = {
  /** Former Remote Config key: global_remote_config* */
  theme: GConfig;
  /** Former Remote Config key: web_config */
  appConfig: AppConfig;
  /** Former Remote Config key: analytics_config */
  analyticsConfig: AnalyticsConfig;
};

/**
 * Central local configuration replacing Firebase Remote Config lookups.
 * Shape matches the previous `getFirebaseConfig()` return value so callers stay unchanged.
 */
export const getAppConfig = async (): Promise<LocalAppConfigBundle> => {
  return {
    theme: remoteConfig as unknown as GConfig,
    appConfig: webConfig,
    analyticsConfig,
  };
};

export { remoteConfig, webConfig, analyticsConfig };
